import React from 'react';

export type StatusOptions = 'success' | 'error' | 'warning' | 'info';

export type ToastContent = string;

export type Id = number | string;

export type Action = {
  title: string;
  onClick?: (e: React.MouseEvent) => void;
  href?: string;
};

export type ToastItemOptions = {
  onClose?: (event: React.MouseEvent) => void;
  status?: StatusOptions;
  showDismiss?: boolean;
  action?: Action;

  dismissTitle?: string;
  dataHook?: string;
};

export type ToastItemProps = ToastItemOptions & {
  children?: React.ReactNode;
  toastId: Id;
  key: Id;
  status: StatusOptions;
  onClose: (event?: React.MouseEvent) => void;
  showDismiss: boolean;
};

export type ToastItem = {
  content: ToastContent;
  props: ToastItemProps;
};
